import { GoogleGenerativeAI } from '@google/generative-ai'

const FIRECRAWL_KEY = process.env.REACT_APP_FIRECRAWL_API_KEY
const genAI = new GoogleGenerativeAI(process.env.REACT_APP_GEMINI_API_KEY as string)

export interface ProgramTuition {
    name: string
    annualTuition: number
}

async function scrapeUrl(url: string): Promise<string> {
    const response = await fetch('https://api.firecrawl.dev/v1/scrape', {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${FIRECRAWL_KEY}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ url, formats: ['markdown'] })
    })
    const data = await response.json()
    return data.data?.markdown || ''
}

async function searchFirecrawl(query: string): Promise<string | null> {
    const response = await fetch('https://api.firecrawl.dev/v1/search', {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${FIRECRAWL_KEY}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ query, limit: 1 })
    })
    const data = await response.json()
    return data.data?.[0]?.url || null
}

export async function fetchSchoolPrograms(school: string): Promise<ProgramTuition[]> {
    const model = genAI.getGenerativeModel({ model: 'gemini-2.5-flash' })

    // Search specifically for program-level fees, not general fee pages
    const url = await searchFirecrawl(
        `${school} tuition fees by program domestic 2025 2026 full-time`
    )

    if (!url) {
        console.log('No fee page found for', school)
        return []
    }

    console.log('Scraping:', url)
    const markdown = await scrapeUrl(url)
    if (!markdown) return []

    const prompt = `
                        This is a fee schedule page from ${school}.
                        
                        Extract a list of SPECIFIC PROGRAMS and their annual domestic tuition fees.
                        
                        Important rules:
                        - Each item must be a real program name (e.g. "Computer Programming", "Business Administration", "Practical Nursing")
                        - Do NOT include generic categories like "Tuition (Canadian citizens)" or "International students" — these are not program names
                        - Do NOT include items where annualTuition is 0 or clearly wrong
                        - If fees are per semester, multiply by 2
                        - If fees are per credit, multiply by 30
                        - Only include entries where you are confident about both the program name AND the fee amount
                        
                        If this page doesn't have program-specific fees and only has generic categories, return [].
                        
                        Return ONLY a raw JSON array:
                        [{ "name": "program name", "annualTuition": number }]
                        
                        Page content:
                        ${markdown.slice(0, 12000)}
                  `

    try {
        const result = await model.generateContent(prompt)
        const text = result.response.text().replace(/```json|```/g, '').trim()
        const parsed = JSON.parse(text)

        return parsed.filter((p: ProgramTuition) =>
            p.annualTuition > 500 &&
            !p.name.toLowerCase().includes('canadian citizen') &&
            !p.name.toLowerCase().includes('international student') &&
            !p.name.toLowerCase().includes('domestic') &&
            !p.name.toLowerCase().includes('tuition (')
        )
    } catch (e) {
        console.error('Program extraction failed:', e)
        return []
    }
}